import { RemoveRedEye } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUserCardViewModel } from 'viewModels';
import { ReactComponent as Icontrash } from '../../../assets/icons/IconTrashCan.svg';
import { ReactComponent as IconChat } from '../../../assets/icons/icon-chat-circle.svg';
import { useAuth } from '../../../context';
import { useConversation } from '../../../context/conversation';
import useClickOutside from '../../../hooks/useClickOutside';
import {
  ClassificationType,
  ContactStatus,
  CorrespondenceType,
  TypeCardUser,
  UserProfileType,
  labelCorrespondenceType,
} from '../../../types/enums';
import { BasicButton } from '../../Buttons/BasicButton';
import { Button } from '../../Buttons/Button';
import { ModalChat } from '../../Modals/ModalChat';
import { UserProfilePicture } from '../../UserProfilePicture';
import { Body, Container, Content, MoreInformationUser, MoreInformationOverlay } from './styles';
import ImageBronze from '../../../assets/images/DiamondBronze.png';
import ImageGold from '../../../assets/images/DiamondGold.png';
import ImageSilver from '../../../assets/images/DiamondSilver.png';
import { ProfileVerified } from '../../Verified';
import { toPattern } from 'vanilla-masker';

interface CardUserProps {
  currentUser: IUserCardViewModel & {
    isFriend?: boolean;
    contactStatus?: ContactStatus;
    selected?: boolean;
  };
  typeUserCard?: TypeCardUser;
  //contact?: IContactViewModel;
  //sendRequestContact?: (contact: IContactViewModel) => void;
  addContactInList?: () => void;
  removeContact?: () => void;
  onViewDetails?: () => void;
  onToggleSelect?: () => void;
}

export function CardUser({
  currentUser,
  typeUserCard,
  // contact,
  // sendRequestContact,
  addContactInList,
  removeContact,
  onToggleSelect,
  onViewDetails,
}: CardUserProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);
  const { getConversationIdByParticipantsIds } = useConversation();
  const [isOpenChat, setIsOpenChat] = useState(false);
  const [conversationIdSelected, setConversationIdSelected] = useState<string>();
  const [isOpenMoreInformation, setIsOpenMoreInformation] = useState(false);

  // const handleSendRequestContact = async (contactUser: IUserCardViewModel) => {
  //   const input: IContactInputModel = {
  //     userId: contactUser.id,
  //     status: ContactStatus.PENDING
  //   };
  //   ContactController.sendRequestContact(input).then((id) => {
  //     const newContact: IContactViewModel = {
  //       id,
  //       userId: contactUser.id,
  //       user: contactUser,
  //       createdById: user?.id,
  //       createdBy: {
  //         id: user?.id,
  //         name: `${userData?.firstName} ${userData?.lastName}`,
  //         profilePictureId: userData?.profilePictureId,
  //         presentation: userData?.presentation,
  //       },
  //       isFriend: false,
  //       status: ContactStatus.PENDING,
  //     };
  //     setContactRequestSent((prev) => {
  //       const newContactRequestSent = [...prev];
  //       if (!newContactRequestSent.some((c) => c.id === newContact.id))
  //         newContactRequestSent.push(newContact);

  //       return newContactRequestSent;
  //     });

  //     sendRequestContact?.(newContact);
  //   });
  // };
  // const handleUpdadeStatusContact = async (status: ContactStatus) => {
  //   if (contact) {
  //     const input: IContactInputModel = {
  //       id: contact.id,
  //       status,
  //     };
  //     ContactController.updateStatusContact(input).then(() => {
  //       setContactRequestReceived((prev) => {
  //         const newContactRequestReceived = prev;
  //         const contactIdx = prev.findIndex((c) => c.id === contact.id);
  //         if (contactIdx !== -1) {
  //           newContactRequestReceived[contactIdx].status = status;
  //           if (status === ContactStatus.RELEASED) {
  //             newContactRequestReceived[contactIdx].isFriend = true;
  //             setContacts((prevContacts) => [...prevContacts, newContactRequestReceived[contactIdx]]);
  //           }
  //         }
  //         return newContactRequestReceived.filter((c) => c.id !== contact.id);
  //       });
  //     });
  //   }
  // };

  const handleSelectConversation = () => {
    if (user.id && currentUser?.id) {
      const participantsIds = [user.id, currentUser?.id];
      getConversationIdByParticipantsIds(participantsIds).then((conversationId) => {
        setConversationIdSelected(conversationId);
        setIsOpenChat(true);
      });
    }
  };

  useClickOutside(() => {
    setIsOpenMoreInformation(false);
  }, ref);

  return (
    <Body>
      <Container className={isOpenMoreInformation ? 'displayNone' : ''}>
        <Content>
          <div className="pictureImage">
            <UserProfilePicture pictureId={currentUser?.profilePictureId} />
          </div>
          <div className="containerCard">
            <div className="card-header">
              <h1>
                {currentUser?.id === user?.id
                  ? 'Você'
                  : `${currentUser?.firstName ?? ''} ${currentUser?.lastName ?? ''}`}
                {currentUser?.profileType === UserProfileType.LAWYER ? (
                  currentUser?.isVerified && (
                    <Tooltip disableInteractive title="Número de inscrição regular no CNA/OAB">
                      <h1>
                        <ProfileVerified color="tertiary_500" />
                      </h1>
                    </Tooltip>
                  )
                ) : (
                  <Tooltip disableInteractive title="Usuário não é um advogado">
                    <h1>
                      <ProfileVerified color="yellow_200" />
                    </h1>
                  </Tooltip>
                )}
              </h1>
              <div className="content-icons-header">
                <button
                  type="button"
                  className="view-user"
                  onClick={() =>
                    onViewDetails ? onViewDetails() : setIsOpenMoreInformation(true)
                  }>
                  <RemoveRedEye />
                </button>
                {typeUserCard === TypeCardUser.FRIEND && (
                  <button type="button" className="remove-from-list" onClick={removeContact}>
                    <Icontrash />
                  </button>
                )}
              </div>
            </div>
            <div className="serviceCard">
              {currentUser.proviedServices?.length &&
                currentUser.proviedServices.map((service, index, array) => (
                  <div key={service.numberProviedServices}>
                    <text className="numberServices">{service.numberProviedServices}</text>
                    <text className="labelCorrespondence">
                      {labelCorrespondenceType[service.type as CorrespondenceType]}
                    </text>
                    {index === array.length - 1 ? '.' : ','}
                  </div>
                ))}
            </div>
            <div className="content-buttons-options">
              {typeUserCard === TypeCardUser.REQUEST_SERVICE && (
                <div className="card-footer">
                  <div className={`btn-container ${'btn-container-left'}`}>
                    {/* {currentUser.inscriptionNumber && (
                      <Tooltip disableInteractive 
                        style={{ fontSize: '5rem' }}
                        placement="top"
                        title="Esse botão vai te redirecionar para o site de consulta do cna, pegue o número de inscição e pesquise neste site"
                        arrow>
                        <span style={{ padding: 0, width: 'min-content' }}>
                          <BasicButton
                            width="9rem"
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              window.open('https://cna.oab.org.br/');
                            }}>
                            situação CNA
                          </BasicButton>
                        </span>
                      </Tooltip>
                    )} */}
                    <div className="diamondCard">
                      {currentUser.classificationType === ClassificationType.BRONZE && (
                        <img src={ImageBronze} alt="" />
                      )}
                      {currentUser.classificationType === ClassificationType.SILVER && (
                        <img src={ImageSilver} alt="" />
                      )}
                      {currentUser.classificationType === ClassificationType.GOLD && (
                        <img src={ImageGold} alt="" />
                      )}
                    </div>
                    <Tooltip
                      disableInteractive
                      style={{ fontSize: '5rem' }}
                      placement="top"
                      title={currentUser?.selected ? 'Selecionado' : 'Selecionar'}
                      arrow>
                      <span
                        style={{
                          padding: 0,
                          width: 'auto',
                          minWidth: '6rem',
                        }}>
                        <BasicButton
                          width="auto"
                          variant={currentUser?.selected ? 'contained' : 'outlined'}
                          onClick={onToggleSelect}
                          style={{
                            fontSize: '0.75rem',
                            padding: '0.3rem 0.8rem',
                            minWidth: '6rem',
                            height: '1.8rem',
                          }}>
                          {currentUser?.selected ? 'Selecionado' : 'Selecionar'}
                        </BasicButton>
                      </span>
                    </Tooltip>
                  </div>
                </div>
              )}
              {typeUserCard === TypeCardUser.ADD_CONTACT_CUSTOM_CONTACTS && (
                <div className="content-button-flex-end">
                  <Button
                    text="Adicionar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                    className="add-contact-from-to-list"
                    onClick={addContactInList}
                  />
                </div>
              )}
              {typeUserCard === TypeCardUser.RESPOND_REQUEST_CONTACT && (
                <div className="content-buttons">
                  <Button
                    text="Recusar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                    color="tertiary_500"
                    backgroundHoverColor="tertiary_500"
                    textHoverColor="background_white"
                  //onClick={() => handleUpdadeStatusContact(ContactStatus.REFUSED)}
                  />
                  <Button
                    text="Aceitar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                  //onClick={() => handleUpdadeStatusContact(ContactStatus.RELEASED)}
                  />
                </div>
              )}
              {typeUserCard === TypeCardUser.FRIEND &&
                (currentUser.isFriend || currentUser.contactStatus === ContactStatus.RELEASED ? (
                  <div className="content-buttons">
                    <button
                      type="button"
                      className="message-card-user"
                      onClick={handleSelectConversation}>
                      <IconChat />
                      Mensagem
                    </button>
                    <Button
                      text="Fazer solicitação"
                      dimensions={{ width: '8.9rem', height: '1.5rem' }}
                      font={{ size: '14' }}
                      onClick={() => navigate('/solicitation')}
                      className="button-solicitation"
                    />
                  </div>
                ) : (
                  <p>Pedido pendente... </p>
                ))}

              {typeUserCard === TypeCardUser.SEND_REQUEST_CONTACT && (
                <div className="content-buttons">
                  {currentUser?.isFriend ? (
                    <Button
                      text="Ver perfil"
                      dimensions={{ width: '6rem', height: '1.5rem' }}
                      font={{ size: '14' }}
                      onClick={() => navigate('/user/*')}
                    />
                  ) : (
                    <Button
                      text="Adicionar"
                      dimensions={{ width: '6rem', height: '1.5rem' }}
                      font={{ size: '14' }}
                    //onClick={() => handleSendRequestContact(currentUser)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </Content>
      </Container>
      {isOpenMoreInformation && (
        <MoreInformationOverlay onClick={() => setIsOpenMoreInformation(false)}>
          <MoreInformationUser onClick={(e) => e.stopPropagation()}>
            <div className="card-header">
              <div className="headerPhotoName">
                <UserProfilePicture pictureId={currentUser?.profilePictureId} />
                <h1>
                  {currentUser?.firstName ?? ''} {currentUser?.lastName ?? ''}
                  {currentUser?.profileType === UserProfileType.LAWYER ? (
                    currentUser?.isVerified && (
                      <Tooltip disableInteractive title="Número de inscrição regular no CNA/OAB">
                        <h1>
                          <ProfileVerified color="tertiary_500" />
                        </h1>
                      </Tooltip>
                    )
                  ) : (
                    <Tooltip disableInteractive title="Usuário não é um advogado">
                      <h1>
                        <ProfileVerified color="yellow_200" />
                      </h1>
                    </Tooltip>
                  )}
                </h1>
              </div>
              <div className="content-icons-header">
                <button
                  type="button"
                  className="view-user"
                  onClick={() => setIsOpenMoreInformation(false)}>
                  <RemoveRedEye />
                </button>
                {typeUserCard === TypeCardUser.FRIEND && (
                  <button type="button" className="remove-from-list">
                    <Icontrash />
                  </button>
                )}
              </div>
            </div>
            <div className="card-infos">
              <div className="service-infos">
                <div className="diamondCard-infos">
                  {currentUser.classificationType === ClassificationType.BRONZE && (
                    <img src={ImageBronze} alt="" />
                  )}
                  {currentUser.classificationType === ClassificationType.SILVER && (
                    <img src={ImageSilver} alt="" />
                  )}
                  {currentUser.classificationType === ClassificationType.GOLD && (
                    <img src={ImageGold} alt="" />
                  )}
                </div>
                <div className="servicesCard-infos">
                  {currentUser.proviedServices &&
                    currentUser.proviedServices.map((service, index, array) => (
                      <div key={service.numberProviedServices}>
                        <span className="numberServices">{service.numberProviedServices}
                          <span className="labelCorrespondence">
                            {" "}{labelCorrespondenceType[service.type as CorrespondenceType]}
                          </span>
                        </span>

                        {index === array.length - 1 ? '.' : ','}
                      </div>
                    ))}
                </div>
              </div>
              <span className="title">
                Email: <span className="content">{currentUser?.email}</span>
              </span>
              {currentUser?.cell && (
                <span className="title">
                  Telefone:{' '}
                  <span className="content">{toPattern(currentUser?.cell, '(99) 99999-9999')}</span>
                </span>
              )}
              {currentUser?.inscriptionNumber && (
                <span className="title">
                  Número de Inscrição OAB:
                  <span className="content">{currentUser?.inscriptionNumber}</span>
                </span>
              )}
            </div>
            <div className="main">
              {currentUser.presentation && (
                <div className="presentationUser">
                  <h2>Carta de apresentação</h2>
                  <p>{currentUser?.presentation}</p>
                </div>
              )}
              {TypeCardUser === undefined && (
                <div className="content-buttons">
                  <BasicButton variant="outlined">Encaminhar proposta</BasicButton>
                </div>
              )}
              {typeUserCard === TypeCardUser.ADD_CONTACT_CUSTOM_CONTACTS && (
                <div className="content-button-flex-end">
                  <Button
                    text="Adicionar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                    className="add-contact-from-to-list"
                    onClick={addContactInList}
                  />
                </div>
              )}
              {typeUserCard === TypeCardUser.RESPOND_REQUEST_CONTACT && (
                <div className="content-buttons">
                  <Button
                    text="Recusar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                    color="tertiary_500"
                    backgroundHoverColor="tertiary_500"
                    textHoverColor="background_white"
                  />
                  <Button
                    text="Aceitar"
                    dimensions={{ width: '6rem', height: '1.5rem' }}
                    font={{ size: '14' }}
                  />
                </div>
              )}
              {typeUserCard === TypeCardUser.FRIEND &&
                (currentUser.isFriend || currentUser.contactStatus === ContactStatus.RELEASED ? (
                  <div className="content-buttons">
                    <button type="button" className="message-card-user">
                      <IconChat />
                      Mensagem
                    </button>
                    <Button
                      text="Fazer solicitação"
                      dimensions={{ width: '8.9rem', height: '1.5rem' }}
                      font={{ size: '14' }}
                      onClick={() => navigate('/solicitation')}
                      className="button-solicitation"
                    />
                  </div>
                ) : (
                  <p>Pedido pendente...</p>
                ))}
            </div>
          </MoreInformationUser>
        </MoreInformationOverlay>
      )}
      <ModalChat
        isOpen={isOpenChat}
        onRequestClose={() => setIsOpenChat(false)}
        conversationId={conversationIdSelected}
      />
    </Body>
  );
}
